module.exports = __webpack_public_path__ + "img/location-text.51e1b752.png";